import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { rateLimitWaitMinutes } from './authErrorKind';
import { authV2Messages } from './authV2Messages';

interface AuthRateLimitTextProps {
  error: Error | null;
}

/**
 * The line of a rate-limit error (design: onboarding g6 "too many tries"). With the wait of the
 * API it says "Try again in N minutes" (Ruling F5); with none, the copy has no number.
 */
const AuthRateLimitTextComponent: React.FC<AuthRateLimitTextProps> = ({ error }) => {
  const intl = useIntl();
  const minutes = rateLimitWaitMinutes(error);
  return (
    <>
      {minutes === null
        ? intl.formatMessage(authV2Messages.codeRateLimit)
        : intl.formatMessage(authV2Messages.codeRateLimitIn, { minutes })}
    </>
  );
};

export const AuthRateLimitText = TypedMemo(AuthRateLimitTextComponent);
